export default __webpack_public_path__ + "static/media/image03.44fce6c8.jpg";